import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Alert,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Row,
  Spinner,
} from "reactstrap";
import { useApi } from "../Api/ApiContext";
import { useAsync } from "react-use";
import Layout, { Main } from "../Layout";

const Faq = () => {
  const { getFaq } = useApi();
  const { value: faqs, loading, error } = useAsync(() => getFaq());

  const [open, setOpen] = useState("1");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };
  if (loading) {
    return (
      <Layout>
        <Main>
          <Row className={"justify-content-center"}>
            <Col xs={2} className="mx-auto">
              <Spinner color={"danger"} />
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }
  if (error) {
    return (
      <Layout backPath={{ pathname: "/" }}>
        <Main>
          <Alert color={"danger"}>
            <h1 className={"fs-4"}>Une erreur est survenue.</h1>
            <p>
              Nos équipes sont mobilisées pour rétablir le service dans les
              meilleurs délai.
            </p>
          </Alert>
        </Main>
      </Layout>
    );
  }
  return (
    <Layout backPath={{ pathname: "/" }}>
      <Main className={"my-4"}>
        <Row>
          <Col lg={10}>
            <h1 className={"fs-1 fw-bold"}>
              Trouvez des réponses à toutes vos questions.
            </h1>
            <Accordion className={"mt-4"} open={open} toggle={toggle}>
              {faqs.map((faq, index) => (
                <AccordionItem key={index}>
                  <AccordionHeader targetId={faq.id}>
                    <b>{faq.name}</b>
                  </AccordionHeader>
                  <AccordionBody accordionId={faq.id}>
                    {faq.entries.map((entry, index) => (
                      <ListGroup key={index}>
                        <ListGroupItem className={"my-3"}>
                          <ListGroupItemHeading>
                            <b>{entry.question}</b>
                          </ListGroupItemHeading>
                          <ListGroupItemText>{entry.answer}</ListGroupItemText>
                        </ListGroupItem>
                      </ListGroup>
                    ))}
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Main>
    </Layout>
  );
};

export default Faq;
